import { Client } from "./client";
import { RequirementEvidenceCategoryCreateData, RequirementEvidenceCategoryUpdateData } from "@/backend/access/requirementEvidenceCategory/types";
import {
  RequirementEvidenceCategoryListResponse,
  RequirementEvidenceCategoryResponse,
  } from "@/backend/express/controllers/requirementEvidenceCategoryController";
import { FusaReply } from "@/types/replyTypes";

export class RequirementEvidenceCategoryController {
  client: Client;

  constructor(client?: Client) {
    this.client = client || new Client();
  }

  fetchCategories(requirementId: string): Promise<RequirementEvidenceCategoryListResponse> {
    return this.client.read(`/api/requirement-evidence-categories/requirement/${requirementId}`);
  }

  createCategory(data: RequirementEvidenceCategoryCreateData): Promise<RequirementEvidenceCategoryResponse> {
    return this.client.create("/api/requirement-evidence-categories", data);
  }

  updateCategory(id: string, data: Omit<RequirementEvidenceCategoryUpdateData, 'id'>): Promise<RequirementEvidenceCategoryResponse> {
    return this.client.update(`/api/requirement-evidence-categories/${id}`, data);
  }

  deleteCategory(id: string): Promise<FusaReply> {
    return this.client.delete(`/api/requirement-evidence-categories/${id}`);
  }
}
